import React from 'react';

const Contrast = ({ className }) => {
    return (
        <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="23" cy="23" r="23" fill="#232328" />
            <circle className='ac-s' cx="22.8679" cy="23.1321" r="6.36792" stroke="white" />
            <path className='ac-f' d="M22.7364 17C26.6023 17 28.7363 19.6863 28.7363 23C28.7363 26.3137 26.6023 29 22.7364 29C22.7364 23 22.7364 26.3137 22.7364 23C22.7364 19.6863 22.7363 23.3458 22.7364 17Z" fill="white" />
        </svg>
    )
}

export default Contrast;